import React from 'react'
import './index.scss'
import { ReactComponent as Done } from 'img/icons/done.svg'
import { ReactComponent as Wrong } from 'img/icons/wrong.svg'
import { Screen } from '../ui/Screen'
import { Card } from '../ui/Card'

interface MessageProps {
	type: 'success' | 'fail'
	message: string
}

export function Message({ type, message }: MessageProps) {
	return (
		<div className="message">
			{type === 'success' && <Done />}
			{type === 'fail' && <Wrong />}
			<div>{message}</div>
		</div>
	)
}

interface MessageScreenProps extends MessageProps {
	footer: React.JSX.Element
}

export function MessageCard({ type, message, footer }: MessageScreenProps) {
	return (
		<Card transperentBackground>
			<Card.Content>
				<Message type={type} message={message} />
			</Card.Content>
			<Card.Footer>{footer}</Card.Footer>
		</Card>
	)
}

export function MessageScreen({ type, message, footer }: MessageScreenProps) {
	return (
		<Screen>
			<MessageCard type={type} message={message} footer={footer} />
		</Screen>
	)
}
